var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "padding-15 border-radius-5 info" },
    [
      _c("base-info"),
      _c(
        "div",
        {
          staticClass:
            "color-bg-fff border-radius-5 padding-10 margin-bottom-20",
        },
        [
          _c("div", { staticClass: "title-box" }, [_vm._v("会员信息")]),
          _c("member-info"),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "color-bg-fff border-radius-5 padding-10 margin-bottom-20",
        },
        [
          _c("div", { staticClass: "title-box" }, [_vm._v("订单信息")]),
          _c("order", {
            attrs: {
              order: _vm.userInfo.orderPage,
              userInfoOrder: _vm.userInfo.userInfoOrderCountVo,
              userId: _vm.userInfo.baseUserInfoVo.userId,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "color-bg-fff border-radius-5 padding-10 margin-bottom-20",
        },
        [
          _c("div", { staticClass: "title-box" }, [
            _vm._v(
              "优惠券 " + _vm._s(_vm.userInfo.customUserRecordPageVoRep.total)
            ),
          ]),
          _c("coupon", {
            attrs: {
              coupon: _vm.userInfo.customUserRecordPageVoRep,
              statisticsUserCoupon: _vm.userInfo.statisticsUserCoupon,
              mobilePhone: _vm.userInfo.baseUserInfoVo.mobilePhone,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "color-bg-fff border-radius-5 padding-10 margin-bottom-20",
        },
        [
          _c("div", { staticClass: "title-box" }, [
            _vm._v("投诉建议 " + _vm._s(_vm.userInfo.suggestionPage.total)),
          ]),
          _c("suggestion", {
            attrs: {
              suggestion: _vm.userInfo.suggestionPage,
              userId: _vm.userInfo.baseUserInfoVo.userId,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "color-bg-fff border-radius-5 padding-10 margin-bottom-20",
        },
        [
          _c("div", { staticClass: "title-box" }, [_vm._v("短信/通知/邮件")]),
          _c("message", {
            attrs: {
              message: _vm.userInfo.messageRecordPage,
              mobile: _vm.userInfo.baseUserInfoVo.mobilePhone,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "color-bg-fff border-radius-5 padding-10 margin-bottom-20",
        },
        [
          _c("div", { staticClass: "title-box" }, [_vm._v("乘车人")]),
          _c("passenger", {
            attrs: {
              passenger: _vm.userInfo.userCommonPassengerPage,
              userId: _vm.userInfo.baseUserInfoVo.userId,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "color-bg-fff border-radius-5 padding-10 margin-bottom-20",
        },
        [
          _c("div", { staticClass: "title-box" }, [_vm._v("接送机订单")]),
          _c("pickup-order", {
            attrs: {
              "first-list": _vm.userInfo.ferryOrderPageRepVo,
              userId: _vm.userInfo.baseUserInfoVo.userId,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }